import { render, staticRenderFns } from "./InternalV2.vue?vue&type=template&id=26f80818&scoped=true"
import script from "./InternalV2.vue?vue&type=script&lang=js"
export * from "./InternalV2.vue?vue&type=script&lang=js"
import style0 from "./InternalV2.vue?vue&type=style&index=0&id=26f80818&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f80818",
  null
  
)

export default component.exports